const memberPromotionRoutes = [
    {
        path: '/promotionBenefits',
        name: 'promotionBenefits',
        component: () => import('../../views/memberPromotion/PromotionBenefits.vue'),
        meta: { title: '推广福利' }
    },
    {
        path: '/promotionRecords',
        name: 'promotionRecords',
        component: () => import('../../views/memberPromotion/PromotionRecords.vue'),
        meta: { title: '推广记录' }
    },
    {
        path: '/integralBenefits',
        name: 'integralBenefits',
        component: () => import('../../views/memberPromotion/IntegralBenefits.vue'),
        meta: { title: '会员积分福利' }
    }
]

export default memberPromotionRoutes

